import React, { useEffect, useState } from 'react';
import styles from './checkListTab.module.css';

import { Button, List } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import greenTick from '../../../../../assets/greenTick.png'
import redTick from '../../../../../assets/redTick.png'
import { AntdSubmit } from '../../../../../components';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import ScheduleMiddleware from '../../../../../store/Middlewares/ScheduleMiddleware';
import AlertAction from '../../../../../store/Actions/AlertActions';


const CheckListTab = () => {
    const navigate = useNavigate();
    const dummyChecklist = new Array(6).fill({
        id: 1,
        checklistName: "Monthly Deep",
        tasks: new Array(4).fill({
            taskName: 'Carpet Cleaning'
        }),
    })


    useEffect(() => {
        getTaskSummary();
        getLanguage();
    }, [])

    const { state } = useLocation();
    const { t, i18n } = useTranslation()
    const data = state;
    const dispatch = useDispatch();
    const [checklistItem, setchecklistItem] = useState([]);

    const getTaskSummary = () => {
        dispatch(ScheduleMiddleware.getPastScheduleTaskSummary(data?.id))
            .then(data => {
                setchecklistItem(data?.data?.checklist);
            })
            .catch(err => console.log(err));
    };

    const getLanguage = async () => {
        try {
            const language = localStorage.getItem('@selectedLanguage');
            i18n.changeLanguage(language)
        } catch (e) {
            console.log(e)
        }
    };

    const updateChecklistRemark = (ID, REMARKS) => {
        let response = {
            checklist_id: ID,
            remarks: REMARKS,
        };
        dispatch(ScheduleMiddleware.updateChecklistRemark(response))
            .then(data => {
                dispatch(AlertAction.ShowAlert({ type: "success", message: data?.message }))
                getTaskSummary();
            })
            .catch(err => console.log(err));
    };

    const handleChange = value => {
        console.log(value);
        if (value == 'Time_Sheet') {
            navigate('/schedule/TimeSheet')
        }
        else if (value == 'Calendar_Schedule') {
            navigate('/schedule/Calendar')
        }

    };

    return (
        <div className={styles.createChecklist_mainContainer}>
            <List
                grid={{
                    gutter: 16,
                    //   xs: 2,
                    sm: 1,
                    md: 1,
                    lg: 2,
                    xl: 2,
                    xxl: 2,
                }}
                // className={styles.createChecklist_list}
                dataSource={checklistItem}
                style={{ width: '100%' }}
                renderItem={(item) => (
                    <div key={item?.id} className={styles.createChecklist_listItem}>
                        <div className={styles.createChecklist_context} >
                            <div className={styles.dataCont}>
                                <div className={styles.createChecklist_heading}>
                                    <h3>{item?.name}</h3>
                                </div>
                                <div>
                                    {/* <p className={styles.createChecklist_para}>{item?.category}</p> */}
                                    {/* <img src={greenTick} alt="" /> */}
                                </div>
                            </div>
                            <div style={{display:'flex',flexDirection:'column',height:'100%',justifyContent:'space-between' }}>

                                <div>

                                    {item?.items?.map((item) => (
                                        <div className={styles.dataCont}>
                                            <div className={styles.createChecklist_heading}>
                                                <p>{item?.name}</p>
                                            </div>
                                            <div>
                                                {/* <p className={styles.createChecklist_para}>{item?.category}</p> */}
                                                {item?.is_completed != 1 ?
                                                    <img src={redTick} alt="" />
                                                    :
                                                    <img src={greenTick} alt="" />
                                                }
                                            </div>
                                        </div>
                                    ))}

                                </div>
                                <div>
                                    {item?.remarks == null ?
                                        <div className={styles.dataCont}>
                                            {/* <div style={{ width: '30%' }}> */}
                                            <Button onClick={() => updateChecklistRemark(item?.id, 'exceed_standard')} type="primary" className={styles.antdButton1}>
                                                Exceed Standard
                                            </Button>
                                            {/* </div> */}
                                            {/* <div style={{ width: '30%' }}> */}
                                            <Button onClick={() => updateChecklistRemark(item?.id, 'meet_standard')} type="primary" className={styles.antdButton2}>
                                                Meet Standard
                                            </Button>
                                            {/* </div> */}
                                            {/* <div style={{ width: '30%' }}> */}
                                            <Button onClick={() => updateChecklistRemark(item?.id, 'below_standard')} type="primary" className={styles.antdButton3}>
                                                Below Standard
                                            </Button>
                                            {/* </div> */}
                                        </div> : null}
                                </div>

                            </div>
                        </div>
                    </div>
                )}
            />
        </div>
    );
};

export default CheckListTab